import React from 'react';
import styles from './OrderStatusBadge.module.css';
import { OrderStatus } from '../ordersTypes';

interface OrderStatusBadgeProps {
  status: OrderStatus;
}

const statusConfig: Record<OrderStatus, { icon: React.ReactNode; className: string }> = {
  Delivered: {
    className: 'delivered',
    icon: <svg viewBox="0 0 16 16" fill="currentColor"><path d="M8 1a7 7 0 100 14A7 7 0 008 1zm-1.4 10.2L3.5 8.1l1-1 2.1 2.1 4.4-4.4 1 1-5.4 5.4z"/></svg>,
  },
  'In Transit': {
    className: 'inTransit',
    icon: <svg viewBox="0 0 16 16" fill="currentColor"><path d="M13.3 4l-1.4-2.7A1 1 0 0011 1H5a1 1 0 00-.9.6L2.7 4H1v8a1 1 0 001 1h.5a2 2 0 004 0h3a2 2 0 004 0H14a1 1 0 001-1V4h-1.7zM4.5 14a1 1 0 110-2 1 1 0 010 2zm7 0a1 1 0 110-2 1 1 0 010 2z"/></svg>,
  },
  Pending: {
    className: 'pending',
    icon: <svg viewBox="0 0 16 16" fill="currentColor"><path d="M8 1a7 7 0 100 14A7 7 0 008 1zm.5 4v3.3l2.8 1.7-.7 1.2L7 9V5h1.5z"/></svg>,
  },
  Processing: {
    className: 'processing',
    icon: <svg viewBox="0 0 16 16" fill="currentColor"><path d="M13 2H3a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1V3a1 1 0 00-1-1zm-3 9H5v-1h5v1zm2-3H5V7h7v1zm0-3H5V4h7v1z"/></svg>,
  },
  Cancelled: {
    className: 'cancelled',
    icon: <svg viewBox="0 0 16 16" fill="currentColor"><path d="M5 11.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM1 1v1.5h1.5l2.7 5.7-1 1.8c-.1.2-.2.5-.2.7a1.5 1.5 0 001.5 1.5h9V10.7H5.6l.8-1.2h5.6a1.5 1.5 0 001.3-.8l2.7-4.8a.7.7 0 00-.6-1.1H3.9L3.2 1H1zm10 10.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"/></svg>,
  },
};

export const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({ status }) => {
  const config = statusConfig[status];
  return (
    <span className={`${styles.badge} ${styles[config.className]}`}>
      <span className={styles.icon}>{config.icon}</span>
      {status}
    </span>
  );
};
